export default __webpack_public_path__ + "static/form-one-column-dont-36ae5a5e3cbcbe1257be65a1ed2b2d3f.png";